module.exports = __webpack_public_path__ + "img/5.cbe42f27.png";